import { createRules as cr } from '@hilma/netina2all';

import { FormRules } from '../types';

const createRules = <R extends FormRules>(rules: R) => cr(rules);

export default createRules;